// import React, { useState } from "react";
import {
  Row,
  Col,
  Card,
  Input,
  Upload,
  message,
  Button,
  Steps,
  Popover,
} from "antd";
import TextInput from "../../components/input/TextInput";
import "./Styles.css";
import { LoadingOutlined } from "@ant-design/icons";
import { BsImage } from "react-icons/bs";
import { useEffect, useState } from "react";
import { AuthAction, UserAction } from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import RMX from "../../assets/images/b-RMX-1.png";
const { TextArea } = Input;

const Personalize = ({ count, onChangeStep }) => {
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [coverUrl, setCoverUrl] = useState("");
  const [coverLoading, setCoverLoadig] = useState(false);
  const [errors, setError] = useState({
    store_urlError: "",
    store_nameError: "",
  });
  const [dataObj, setDataObj] = useState({
    logo: "",
    description: "",
  });
  const dispatch = useDispatch();

  const uploadProfileButton = (
    <div>
      {loading ? <LoadingOutlined size={25} /> : <BsImage size={25} />}
      <div style={{ marginTop: 3 }}>ADD AN IMAGE</div>
    </div>
  );


  function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(img);
  }

  function beforeUpload(file) {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      message.error("You can only upload JPG/PNG file!");
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error("Image must smaller than 2MB!");
    }
    return isJpgOrPng && isLt2M;
  }

  const handleChange = (info) => {
    if (info.file.status === "uploading") {
      setLoading(true);
      return;
    }
    if (info.file.status === "done") {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, (imageUrl) => {
        setDataObj({
          ...dataObj,
          logo: info.file.originFileObj,
        });
        setLoading(false);
        setImageUrl(imageUrl);
      });
    }
  };
  const onHandleCover = (info) => {
    if (info.file.status === "uploading") {
      setCoverLoadig(true);
      return;
    }
    if (info.file.status === "done") {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, (imageUrl) => {
        setDataObj({
          ...dataObj,
          cover: info.file.originFileObj,
        });
        setCoverLoadig(false);
        setCoverUrl(imageUrl);
      });
    }
  };
  const { Step } = Steps;
  const customDot = (dot, { status, index }) => (
    <Popover
      content={
        <span>
          step {index} status: {status}
        </span>
      }
    >
      {dot}
    </Popover>
  );
  const onHandleChange = (e) => {
    setDataObj({
      ...dataObj,
      [e.target.name]: e.target.value,
    });
    setError({
      ...errors,
      [`${e.target.name}Error`]: "",
    });
  };
  const onSubmit = () => {
    
    dispatch(UserAction.createAssetsReq(dataObj, () => onChangeStep()));
  };

  return (
    <Row justify="center">
      <Col xs={24} sm={24} md={24} xl={24} lg={24}>
        <Card
          style={{
            boxShadow: 'boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px',
            border: "solid lightgrey 1px",
          }}
        >
          <Row>
            <Col
              xl={24}
              lg={24}
              xs={24}
              sm={24}
              md={24}
              style={{
                padding: "15px",
                justifyContent: "start",
                display: "flex",
                marginTop: "20px",
              }}
            >
              <img
                src={RMX}
                style={{
                  maxWidth: "100%",
                  height: "auto",
                  backgroundRepeat: "no-repeat",
                  top: "-20px",
                  paddingLeft: "50px",
                }}
              />
            </Col>
          </Row>
          <Steps current={count} progressDot={customDot}>
            {/* <Step title="Register" /> */}
            <Step title="Create Profile" />
            <Step title="Add Location" />
            <Step title="Personlize" />
            <Step title="Subscription" />
          </Steps>
          <div
            style={{
              width: "90%",
              margin: "auto",
              // boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
              border: "solid #eaeaea 1px",
              padding: "1rem",
              marginTop: "20px",
            }}
          >
            <Col className="login-card">
              <h2 className="text-left">Store Customization</h2>
            </Col>
            <Row justify="start">
              <Col
                xs={24}
                sm={24}
                md={12}
                xl={8}
                lg={8}
                className="cardpadding "
              >
                <Upload
                  name="Add an Image"
                  listType="picture-card"
                  className="avatar-uploader"
                  showUploadList={false}
                  action="https://ej2.syncfusion.com/services/api/uploadbox/Save"
                  beforeUpload={beforeUpload}
                  onChange={handleChange}
                >
                  {imageUrl ? (
                    <img
                      src={imageUrl}
                      alt="avatar"
                      style={{
                        width: "8rem",
                        height: "8rem",
                        objectFit: "cover",
                        borderRadius: "80px",
                      }}
                    />
                  ) : (
                    uploadProfileButton
                  )}
                </Upload>
              </Col>
              <Col
                xs={24}
                sm={24}
                md={12}
                xl={16}
                lg={16}
                style={{
                  borderLeft: "0.5px solid lightgrey ",
                  padding: "10px",
                }}
              >
                <Row justify="start" gutter={[30, 0]}>
                
                  <Col xs={24} sm={24} md={24} xl={12} lg={12} className="text-left">
                    <span className="link-preview">Preview:</span>
                    <span>
                      {" "}
                      {`http://logistics.stg.surface-tech.com`}
                    </span>
                  </Col>
                  <Col xs={24} sm={24} md={24} xl={24} lg={24}>
                    <TextArea
                      style={{
                        backgroundColor: "rgba(226, 226, 226, 0.26)",
                        border: "#edeff0 1px solid",
                      }}
                      rows={6}
                      className="textArea-resize"
                      name="description"
                      onChange={onHandleChange}
                      value={dataObj.description}
                      placeholder="Description About Us"
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>

          <Row
            justify="end"
            style={{ marginBottom: "20px", marginTop: "20px" }}
          >
            <Col xs={24} sm={24} md={10} lg={8} xl={8}>
              <Button
                style={{
                  backgroundColor: "#ff9800",
                  color: "#fff",
                  width: "50%",
                  marginTop: "10px",
                }}
                onClick={() => onSubmit()}
              >
                BUILD CATALOG
              </Button>
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  );
};

export default Personalize;
